import { Flex } from '@chakra-ui/react';
import { useGetLastRefreshTimeQuery } from '@/store/query/ats-reports';
import dayjs from 'dayjs';
import { useMemo } from 'react';
import { KText } from '@/ui-library/components/text';
export const LastRefreshedTime = ({
  scope = 'applications',
}: {
  scope: string;
}) => {
  const { isLoading, data } = useGetLastRefreshTimeQuery({ scope });

  const date = useMemo(() => {
    if (isLoading) return;
    if (!data?.[0]?.timestamp) return null;
    return dayjs(data?.[0]?.timestamp).format('DD MMMM YYYY, h:mm A');
  }, [data, isLoading]);

  return (
    <Flex flex="1" justifyContent="end" alignItems="center">
      <Flex bg="secondary-50" p="4px 8px" borderRadius="sm">
        <KText color="secondary-900" size="sm-semi-bold">
          Data refreshed:
        </KText>
        <KText size="sm-medium" color="secondary-700" ml="4px">
          {date || 'NA'}
        </KText>
      </Flex>
    </Flex>
  );
};
